import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap';
import useAttestatoSpedizione from '../../hooks/useAttestatoSpedizione';
import { useSelector } from 'react-redux';

const SpedizioneAttestatoModal = ({ show, onHide, attestatoData, onUpdate }) => {
    
    const { isLoading, saveSpedizione } = useAttestatoSpedizione();
    const userLoggedIn = useSelector(state => state.user.userData);
    
    const [formData, setFormData] = useState({});

    // Questo useEffect popola il form con i dati esistenti quando la modale si apre
    useEffect(() => {
        if (attestatoData) {
            setFormData({
                id_attestato: attestatoData.id_attestato,
                data_spedizione: attestatoData.data_spedizione ? new Date(attestatoData.data_spedizione).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
                tracking_spedizione: attestatoData.tracking_spedizione || 'https://www.nuovaposta.com/tracking/',
                soggetto_spedizione: attestatoData.soggetto_spedizione || 'corsista',
                id_agenzia_spedizione: attestatoData.id_agenzia_spedizione || null,
                id_superpartner_spedizione: attestatoData.id_superpartner_spedizione || null,
            });
        }
    }, [attestatoData, show]);

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        const newFormData = { ...formData, [name]: value };

        // Logica "intelligente" per auto-popolare gli ID
        if (name === 'soggetto_spedizione') {
            if (value === 'agenzia') {
                newFormData.id_agenzia_spedizione = attestatoData.id_agenzia;
                newFormData.id_superpartner_spedizione = null;
            } else if (value === 'superpartner') {
                newFormData.id_agenzia_spedizione = null;
                newFormData.id_superpartner_spedizione = attestatoData.id_superpartner;
            } else { // caso 'corsista'
                newFormData.id_agenzia_spedizione = null;
                newFormData.id_superpartner_spedizione = null;
            }
        }
        setFormData(newFormData);
    };

    const handleSave = async () => {
        const payload = { ...formData };
        const success = await saveSpedizione(payload);
        if (success) {
            onUpdate(); // Funzione per ricaricare i dati nella pagina principale
            onHide();
        }
    };


    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Gestione Spedizione Attestato</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info">
                    Stai inserendo i dati di spedizione per l'utente: <strong> {attestatoData?.nome} {attestatoData?.cognome}</strong>
                </Alert>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group className="mb-3">
                        <Form.Label>Data Spedizione</Form.Label>
                        <Form.Control type="date" name="data_spedizione" value={formData.data_spedizione || ''} onChange={handleFormChange} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>URL Tracking Spedizione</Form.Label>
                                                <Form.Control
                            type="text"
                            name="tracking_spedizione"
                            placeholder="Inserisci il link di tracking"
                            value={formData.tracking_spedizione || ''}
                            onChange={handleFormChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();   // blocca la submit
                                    e.stopPropagation();  // blocca la propagazione
                                    // opzionale: qui puoi chiamare la funzione di salvataggio
                                    // handleSave();
                                }
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Spedito a</Form.Label>
                        <Form.Select name="soggetto_spedizione" value={formData.soggetto_spedizione || 'corsista'} onChange={handleFormChange}>
                            <option value="corsista">Corsista</option>
                            {/* Mostra le opzioni solo se l'utente è legato a un'agenzia o superpartner */}
                            {attestatoData?.id_agenzia && <option value="agenzia">Agenzia di appartenenza</option>}
                            {attestatoData?.id_superpartner && <option value="superpartner">Superpartner di appartenenza</option>}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Annulla</Button>
                <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                    {isLoading ? <Spinner as="span" size="sm" /> : "Salva Spedizione"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SpedizioneAttestatoModal;